import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MDialog from "components/Shared/MDialog.tsx";
import { MSelect, MSpinner } from "components/Shared";
import { Button } from "react-md";
import responseHandler from "responseHandler";
import { updateQuickListInPlace } from "actions/homeowner/quickList";
import { assignIncidents } from "requests/customerService/index.ts";

const IncidentAssign = props => {
  const [selectedUser, setSelectedUser] = useState("");
  const [isAssigning, setIsAssigning] = useState(false);
  const [assignToUsersList, setAssignToUsersList] = useState([]);
  const mounted = useRef(true);

  useEffect(() => {
    return (() => { mounted.current = false; });
  }, []);

  useEffect(() => {
    // We shouldn't have to request assignToUsers here as it's done in the Quicklist component
    if (props.assignToUsers.length > 0) {
      setAssignToUsersList(props.assignToUsers);
      // Default to the first user in the list to match the dropdown default
      setSelectedUser(props.assignToUsers[0]);
    }
  }, [props.assignToUsers]);

  const getContentActions = () => {
    if (isAssigning) return [];
    const actions = [
      <Button key="cancelAssignIncident" raised onClick={props.hideDialog} >Cancel</Button>
    ];
    if (props.selectedIncidentIds.length > 0) {
      actions.unshift(<Button key="assignIncident" primary raised onClick={onAssign} >Assign</Button>);
    }
    return actions;
  };

  const onAssign = () => {
    setIsAssigning(true);
    // Mueller.Business.Models.CustomerService.CustomerServiceIncidentsAssign
    const payload = {
      incidentIds: props.selectedIncidentIds,
      internetUserId: selectedUser.value,
    };
    assignIncidents(payload, onSuccess, finishAssigning, mounted);
  };

  const onSelectionChange = (option) => {
    setSelectedUser(option);
  };

  const createQuicklistUpdate = () => {
    const update = props.selectedIncidentIds.map(i => {
      return {
        incidentId: i,
        assignedUser: selectedUser.label,
        assignedInternetUserId: selectedUser.value,
        updatedDaysAgo: 0
      };
    });
    return {
      id: props.selectedQuickListId,
      key: "incidentId",
      update
    };
  };

  const onSuccess = () => {
    let update = createQuicklistUpdate();
    props.updateQuickList(update);
    props.makeToast("Incidents assigned", "success");
    finishAssigning();
  };

  const finishAssigning = () => {
    props.hideDialog();
    setIsAssigning(false);
  };

  return (
    <MDialog
      id="assign-incidents-dialog"
      className="assign-incidents-dialog"
      title="Assign Incidents"
      contentClassName="assign-incidents-dialog-content"
      visible={props.visible}
      contentActions={getContentActions()}
    >
      {(props.isFetchingUsers || isAssigning) && <MSpinner />}
      {props.selectedIncidentIds.length === 0 && !isAssigning && <p>No incidents selected. Please use the checkboxes to select incidents to assign.</p>}
      {props.selectedIncidentIds.length > 0 && !props.isFetchingUsers && !isAssigning && <>
        <p>{`${props.selectedIncidentIds && props.selectedIncidentIds.length} ${props.selectedIncidentIds.length > 1 ? "incidents" : "incident"} selected. Choose a user to assign to:`}</p>
        <MSelect
          id="assign-incidents-mselect"
          className="assign-incidents-dropdown"
          isClearable={false}
          onChange={onSelectionChange}
          options={assignToUsersList}
          defaultValue={assignToUsersList[0]}
          getMenuPortalTarget={() => document.querySelector(".assign-incidents-dialog")}
        />
      </>}
    </MDialog>
  );
};

IncidentAssign.propTypes = {
  selectedIncidentIds: PropTypes.arrayOf(PropTypes.number), // Array of incident IDs
  visible: PropTypes.bool,  // Show/hide dialog
  hideDialog: PropTypes.func, // Function to call to close this dialog
  selectedQuickListId: PropTypes.number, // Id of the selected quicklist

  // Redux
  isFetchingUsers: PropTypes.bool,
  assignToUsers: PropTypes.arrayOf(PropTypes.object),
};

IncidentAssign.defaultProps = {
  selectedIncidentIds: [],
  visible: false,
};

const mapStateToProps = state => {
  return {
    isFetchingAssignToUsers: state.customerService.isFetchingAssignToUsers,
    assignToUsers: state.customerService.assignToUsers,
  };
};

const mapDispatchToProps = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
  updateQuickList(update) {
    dispatch(updateQuickListInPlace(update));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(IncidentAssign);